import * as React from "react";
import { hashHistory } from "react-router";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Tagline } from "../../components/start/tagline";
import { Header } from "../../components/start/header";
import { Tutorial } from "../../components/start/tutorial";
import { FactSlider } from "../../components/start/factSlider";
import { Primary } from "../../components/start/primary";
import { Secondary } from "../../components/start/secondary";
import { Tertiary } from "../../components/start/tertiary";
import * as s from "./start.css";


@inject("store") @observer
export default class StartVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  componentWillMount(): void {
    window.scrollTo(0, 0);
    this.props.store.getHelpTopics();
  }

  renderTagline(): JSX.Element {
    return (<Row><Tagline store={this.props.store} /></Row>)
  }

  renderHeader(): JSX.Element {
    return (<Header store={this.props.store} />)
  }

  renderTutorial(): JSX.Element {
    return (<Row><Tutorial store={this.props.store} /></Row>)
  }

  renderSlider(): JSX.Element {
    return (<Row><FactSlider store={this.props.store} /></Row>)
  }

  renderPrimarySection(): JSX.Element {
    return (<Row><Primary store={this.props.store} /></Row>)
  }

  renderSecondarySection(): JSX.Element {
    return (<Row><Secondary store={this.props.store} /></Row>)
  }

  renderTertiarySection(): JSX.Element {
    return (<Row><Tertiary store={this.props.store} /></Row>)
  }
  render(): JSX.Element {
    return (<Grid className={s.grid}>
      <Row>
        <Col xs={12}>
          {this.renderTagline()}
          {this.renderHeader()}
          {this.renderTutorial()}
          {this.renderSlider()}        
          {this.renderPrimarySection()}
          {this.renderSecondarySection()}
          {this.renderTertiarySection()}
        </Col>
        </Row>
    </Grid>)

  }

}



// WEBPACK FOOTER //
// ./src/views/start/index.tsx